export default "__VITE_ASSET__DqGAY8gl__"